module.exports = __webpack_public_path__ + "img/teacherNo4.6fd140e0.png";